












































































































































import { Inject } from 'inversify-props';
import { Component, Mixins } from 'vue-property-decorator';

import ClipText from '@/modules/common/filters/clip-text.filter';
import DragScrollMixin from '@/modules/common/mixins/drag-scroll.mixin';
import DocumentFiltersService, { DocumentFiltersServiceS } from '@/modules/document-filters/document-filters.service';
import HotelsService, { HotelsServiceS } from '@/modules/hotels/hotels.service';
import PromotionsService, { PromotionsServiceS } from '../promotions.service';

const dateFormat = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'numeric', day: '2-digit' });

@Component({
    filters: {
        ClipText(value: string) {
            return ClipText(value, 30);
        },
    },
})
export default class PromotionsTable extends Mixins(DragScrollMixin) {
    @Inject(PromotionsServiceS)
    private promotionsService!: PromotionsService;

    @Inject(DocumentFiltersServiceS)
    private documentFiltersService!: DocumentFiltersService;

    @Inject(HotelsServiceS)
    private hotelsService!: HotelsService;

    public averageValues = {
        deals: [] as number[],
        programs: [] as number[],
    };

    public get isNoData() {
        if (this.isLoading) return false;
        if (!this.promotionsService.data) return true;

        return !Object.keys(this.promotionsService.data.providerData).length;
    }

    private get mainHotelId() {
        return +this.$route.params.hotelId;
    }

    public get mainHotelLabel() {
        return this.hotelsService.getHotelName(this.mainHotelId);
    }

    public get isLoading() {
        return this.promotionsService.isLoading;
    }

    public get dummyData() {
        const { days } = this.documentFiltersService;

        return days
            .map(__ => Array
                .from({ length: 7 })
                .map(_ => ({
                    dealProgramsCount: '99',
                    defaultProgramsCount: '99',
                })));
    }

    public get tableData() {
        const { days } = this.documentFiltersService;
        const { provider, data } = this.promotionsService;

        if (this.isLoading) {
            return this.dummyData;
        }

        if (!data || !provider) return [];

        const averageDeals = [] as number[];
        const averagePrograms = [] as number[];

        const rowsData = days.map(day => {
            let averageDealCount = 0;
            let averageProgramsCount = 0;
            const competitorsCount = data.hotels.length - 1;

            const hotelsData = data.hotels
                .filter(hotelId => +hotelId !== this.mainHotelId)
                .map(hotelId => {
                    const programs = Object
                        .values(this.promotionsService
                            .getPrograms(day, provider, hotelId) || {});
                    const dealsCount = programs
                        .filter(program => ('percentage' in program) && program.status).length;
                    const programsCount = programs
                        .filter(program => !('percentage' in program) && program.status).length;

                    averageDealCount += dealsCount;
                    averageProgramsCount += programsCount;

                    return {
                        hotelId,
                        day,
                        dealsCount,
                        programsCount,
                    };
                });

            averageDeals.push(averageDealCount / competitorsCount);
            averagePrograms.push(averageProgramsCount / competitorsCount);

            return hotelsData;
        });

        this.averageValues.deals = averageDeals;
        this.averageValues.programs = averagePrograms;

        return rowsData;
    }

    public get mainData() {
        const { days, year, month } = this.documentFiltersService;
        const { provider } = this.promotionsService;

        if (!provider) return [];

        return days.map((day, index) => {
            const programs = Object.values(
                this.promotionsService
                    .getPrograms(day, provider, this.mainHotelId) || {},
            );

            const dealsCount = programs
                .filter(program => ('percentage' in program) && program.status).length;
            const programsCount = programs
                .filter(program => !('percentage' in program) && program.status).length;

            const averageDeal = this.averageValues.deals[index];
            const averageProgram = this.averageValues.programs[index];

            let dealsStatus = 'yellow';
            let programStatus = 'yellow';

            if (averageDeal !== dealsCount) {
                dealsStatus = averageDeal > dealsCount
                    ? 'red'
                    : 'green';
            }

            if (averageProgram !== programsCount) {
                programStatus = averageProgram > programsCount
                    ? 'red'
                    : 'green';
            }

            return {
                hotelId: this.mainHotelId,
                day,
                dealsCount,
                programsCount,
                date: dateFormat.format(new Date(year, month, day)),
                dealsStatus,
                programStatus,
            };
        });
    }

    public get hotelList() {
        const { competitors } = this.promotionsService;
        if (this.isLoading) return Array.from({ length: 7 }).map(_ => '_____________');
        if (!competitors) return [];

        return competitors
            .map(hotelId => this.hotelsService.getHotelName(hotelId));
    }

    public openPopup(day: number) {
        if (this.isDragging()) return;

        this.$router.push({
            name: 'hotel.promotions.table.popup',
            params: {
                ...this.$route.params,
                day: String(day),
            },
        });
    }
}
